export default __webpack_public_path__ + "static/different-041f7b181c61793d831e0b3c291bfe27.png";